import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IIntern } from '../types';
import { InternRow } from './intern-row';

const TABLE_HEAD = [
  { id: 'id', label: 'Id', align: 'center' },
  { id: 'firstName', label: 'Name', align: 'center' },
  { id: 'email', label: 'Email', align: 'center' },
  { id: 'phone', label: 'Phone', align: 'center', sortable: false },
  { id: 'source', label: 'Source', align: 'center' },
  { id: 'status', label: 'Status', align: 'center', sortable: false },
  { id: 'action', label: 'Action', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  rows?: IIntern[];
  loading: boolean;
}

const InternList = ({ tableProps, rows, loading }: Props) => (
  <PaginatedTable<IIntern>
    head={TABLE_HEAD}
    tableProps={tableProps}
    data={rows}
    loading={loading}
    isServerSidePaging={false}
  >
    {(row) => (
      <InternRow
        row={row}
        selected={tableProps.selected.includes(row.id)}
        onSelectRow={() => {
          ('');
        }}
      />
    )}
  </PaginatedTable>
);
export { InternList };
